<template>
  <div
    class="tw-p-[40px] tw-text-[15px] tw-flex tw-flex-col tw-gap-[20px] tw-items-start tw-justify-between tw-py-[40px] tw-text-[#231F20] tw-borer tw-border-[0px] tw-border-t tw-border-solid tw-border-[#EEF0F1]"
  >
    <div
      class="tw-w-full tw-text-[16px] tw-leading-[130%] tw-font-semibold tw-mb-[5px]"
    >
      <b-row>
        <b-col sm="5">
          <div
            class="tw-flex tw-items-center tw-justify-start tw-gap-[10px] tw-text-[#211F58] tw-mb-[10px]"
          >
            {{
              getComponentUiText(
                "app-vendor-create-new-vendor-assessment-modal-title-recipient-details-1",
              )
            }}
            <ButtonShowDuplicateAssessment
              :id-popover="'popover-recipient-details'"
              :custom-class="'tw-w-[max-content] md:tw-min-w-[500px] md:tw-max-w-[350px] lg:tw-max-w-[470px]'"
              :class="`!tw-p-0 tw-leading-[16px]`"
              :classes="`!tw-leading-none`"
            >
              <div class="tw-p-[25px]">
                <div
                  class="tw-flex tw-flex-col tw-gap-4 tw-text-[11px] tw-font-[400] tw-text-[#231F20]"
                >
                  <div
                    class="tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins"
                  >
                    {{
                      getComponentUiText(
                        "app-vendor-create-new-vendor-assessment-modal-title-recipient-details-1",
                      )
                    }}
                  </div>
                  <CustomDescriptionContent
                    :description="
                      getComponentUiText(
                        'app-vendor-create-new-vendor-assessment-modal-popover-description-recipient-details-vendor-1',
                      )
                    "
                    :class="`!tw-p-0 tw-text-[13px] tw-text-[#878787]`"
                  >
                  </CustomDescriptionContent>
                </div>
              </div>
            </ButtonShowDuplicateAssessment>
          </div>
          <div
            class="tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-normal tw-w-full tw-flex"
          >
            {{
              getComponentUiText(
                "app-vendor-create-new-vendor-assessment-modal-description-recipient-details-1",
              )
            }}
          </div>
        </b-col>
        <b-col sm="7">
          <div
            v-if="showPrePopulateWarning"
            class="tw-flex tw-items-center tw-bg-[#FE9A0526] tw-text-[11px] tw-text-[#FE9A05] tw-font-medium tw-mt-[10px] tw-leading-[130%] tw-py-[8px] tw-px-[12px] tw-rounded-md"
          >
            <div
              class="tw-flex tw-item-center tw-w-[16px] tw-h-[16px] tw-mr-[10px]"
            >
              <img src="@/assets/img/warning-orange-icon.svg" />
            </div>
            <span>{{
              getComponentUiText(
                "app-vendor-create-new-vendor-assessment-modal-recipient-details-warning-1",
              )
            }}</span>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Name -->
    <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
      <BaseInput
        id="name"
        v-model="formModel.name"
        :validation="$v.name"
        :container="'tw-w-full '"
        data-cy-id="recipient-details-name"
        :class-name="'!tw-items-center !tw-mt-[0px]'"
        :is-required="true"
        :label="'Name'"
        :placeholder="
          getComponentUiText('app-vendor-dropdown-placehoder-base-input-name-1')
        "
        @blur="
          () => {
            $v.name.$validate();
          }
        "
      >
      </BaseInput>
    </div>

    <!-- Email -->
    <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
      <BaseInput
        id="email"
        v-model="formModel.email"
        :container="'tw-w-full '"
        data-cy-id="recipient-details-email"
        :class-name="'!tw-items-center !tw-mt-[0px]'"
        :validation="$v.email"
        :label="
          getComponentUiText('app-vendor-dropdown-label-base-input-email-1')
        "
        :placeholder="
          getComponentUiText(
            'app-vendor-dropdown-placehoder-base-input-email-1',
          )
        "
        @blur="
          () => {
            $v.email.$validate();
          }
        "
      >
      </BaseInput>
    </div>

    <!-- Expiry date -->
    <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
      <BaseInput
        id="expiryDate"
        v-model="formModel.expiryDate"
        :container="'tw-w-full '"
        :class-name="'!tw-items-center !tw-mt-[0px]'"
        :validation="$v.expiryDate"
        :label="
          getComponentUiText(
            'app-vendor-dropdown-lable-base-input-expiry-date-1',
          )
        "
        :label-tooltip="
          getComponentUiText(
            'app-vendor-dropdown-label-tooltip-base-input-expiry-date-1',
          )
        "
      >
        <div
          class="input-container expiryDate-container tw-flex tw-ml-[16px] tw-gap-[25px]"
        >
          <div
            class="input-container tw-flex-1 xl:tw-flex-row tw-flex-col tw-flex"
          >
            <div
              class="tw-flex tw-items-start sm:tw-items-center tw-gap-2 sm:tw-gap-0 sm:tw-flex-row tw-flex-col tw-min-w-full tw-justify-between"
            >
              <BaseCheckbox
                :text="
                  getComponentUiText(
                    'app-assessment-vendor-option-expiry-date-1week-1',
                  )
                "
                :class="'tw-min-w-max'"
                data-cy="expiry-date-option-1-week"
                :text-style="'tw-text-[13px] !tw-font-[500] tw-text-[#231F20] tw-whitespace-nowrap'"
                color="#387DFF"
                :ticked="
                  formModel.expiryDateOption ===
                  OPTION_EXPIRY_DATE_VENDOR.ONE_WEEK
                "
                :disabled="false"
                @selected="
                  () => {
                    handleSelectExpiryOption(
                      OPTION_EXPIRY_DATE_VENDOR.ONE_WEEK,
                    );
                  }
                "
                @unselected="() => {}"
              />
              <BaseCheckbox
                :text="
                  getComponentUiText(
                    'app-assessment-vendor-option-expiry-date-2weeks-1',
                  )
                "
                :text-style="'tw-text-[13px] !tw-font-[500] tw-text-[#231F20] tw-whitespace-nowrap'"
                data-cy="expiry-date-option-2-week"
                color="#387DFF"
                :ticked="
                  formModel.expiryDateOption ===
                  OPTION_EXPIRY_DATE_VENDOR.TWO_WEEKS
                "
                :disabled="false"
                @selected="
                  () => {
                    handleSelectExpiryOption(
                      OPTION_EXPIRY_DATE_VENDOR.TWO_WEEKS,
                    );
                  }
                "
                @unselected="() => {}"
              />
              <div class="tw-flex tw-items-center tw-flex-row">
                <BaseCheckbox
                  :text="
                    getComponentUiText(
                      'app-assessment-vendor-option-expiry-date-custom-1',
                    )
                  "
                  :text-style="'tw-text-[13px] tw-text-[#231F20] !tw-font-[500]'"
                  data-cy="expiry-date-option-custom"
                  color="#387DFF"
                  :ticked="
                    formModel.expiryDateOption ===
                    OPTION_EXPIRY_DATE_VENDOR.CUSTOM
                  "
                  :disabled="false"
                  @selected="
                    () => {
                      handleSelectExpiryOption(
                        OPTION_EXPIRY_DATE_VENDOR.CUSTOM,
                      );
                    }
                  "
                  @unselected="() => {}"
                />
                <DatePickInput
                  v-model="customExpiryDate"
                  :placeholder="
                    formModel.expiryDateOption ===
                      OPTION_EXPIRY_DATE_VENDOR.CUSTOM ||
                    !formModel.expiryDateOption
                      ? getComponentUiText(
                          'app-menu-submenu-home-setup-wizard-start-date-title',
                        )
                      : convertUTCTimeToLocalTime(formModel.expiryDate ?? '')
                  "
                  :disabled="
                    formModel.expiryDateOption !==
                    OPTION_EXPIRY_DATE_VENDOR.CUSTOM
                  "
                  :class-name="`tw-w-[215px] tw-ml-[9px]`"
                  data-cy-id="expiry-date-option-custom-input"
                  :focus="true"
                  :custom-input-class="'tw-flex tw-flex-1'"
                  :validation="
                    formModel.expiryDateOption ===
                    OPTION_EXPIRY_DATE_VENDOR.CUSTOM
                      ? $v.expiryDate
                      : {}
                  "
                  @update:model-value="
                    (value) => (value ? (formModel.expiryDate = value) : '')
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </BaseInput>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  getComponentUiText,
  IsEmailValidWhileTyping,
  IsSpecialCharEmailValid,
} from "@/utils/utilities";
import { reactive, watch, defineExpose, ref } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { email, helpers, required } from "@vuelidate/validators";
import BaseInput from "../common/form/baseInput.vue";
import DatePickInput from "../common/datePickInput.vue";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";
import BaseCheckbox from "../common/form/baseCheckbox.vue";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import { OPTION_EXPIRY_DATE_VENDOR } from "@/utils/constants";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  showWarning: {
    type: Boolean,
    required: false,
  },
});

const showPrePopulateWarning = ref(props.showWarning);

const formModel = reactive({
  ...props.modelValue,
});
// formModel.expiryDateOption = OPTION_EXPIRY_DATE_VENDOR.ONE_WEEK;

const customExpiryDate = ref(
  formModel.expiryDateOption === OPTION_EXPIRY_DATE_VENDOR.CUSTOM
    ? formModel.expiryDate
    : "",
);

const emit = defineEmits(["update:isDisabled", "update:modelValue"]);

const rules = {
  name: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  email: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    specialChar: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsEmailValidWhileTyping,
    ),
    email: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsSpecialCharEmailValid,
    ),
  },
  expiryDate: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    isFutureOrToday: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-vendor-dropdown-validation-base-input-expiry-date-1",
        ),
      (value: string) => {
        if (!value) return true;
        return new Date(value) >= new Date();
      },
    ),
  },
};

const $v = useVuelidate(rules, formModel as any);

watch(
  () => formModel,
  (value) => {
    emit("update:modelValue", value);
    if (formModel.expiryDateOption === OPTION_EXPIRY_DATE_VENDOR.CUSTOM) {
      customExpiryDate.value = value.expiryDate;
    }
    if (value.name && value.email && value.expiryDate) {
      emit("update:isDisabled", true);
    } else {
      emit("update:isDisabled", false);
    }
  },
  { deep: true },
);

watch(
  () => props.showWarning,
  (value) => {
    showPrePopulateWarning.value = value;
  },
);

watch(
  () => props.modelValue,
  (value) => {
    Object.assign(formModel, value);
  },
  { deep: true },
);

const isCheckValid = async () => {
  await $v.value.$validate();
  return !$v.value.$error;
};

const handleSelectExpiryOption = (option: string) => {
  formModel.expiryDateOption = option;
  const date = new Date();
  date.setHours(0, 0, 0, 0);

  switch (option) {
    case OPTION_EXPIRY_DATE_VENDOR.ONE_WEEK:
      date.setDate(date.getDate() + 7);
      formModel.expiryDate = date.toISOString();
      customExpiryDate.value = "";
      break;
    case OPTION_EXPIRY_DATE_VENDOR.TWO_WEEKS:
      date.setDate(date.getDate() + 14);
      formModel.expiryDate = date.toISOString();
      customExpiryDate.value = "";
      break;
    case OPTION_EXPIRY_DATE_VENDOR.CUSTOM:
      if (!customExpiryDate.value) {
        formModel.expiryDate = "";
      }
      break;
  }
};

defineExpose({
  isCheckValid,
});
</script>
